import React, {createContext, useContext, useMemo} from 'react';

const defaultI18n = {locale: 'en', tz: 'UTC', t: {}};
export const I18nContext = createContext(defaultI18n);

export function I18nProvider({locale = 'en', tz = 'UTC', dictionaries = {}, children}) {
    const dict = dictionaries?.[locale] || {};
    const value = useMemo(() => ({locale, tz, t: dict}), [locale, tz, dict]);
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    return ctx || defaultI18n;
}

export function withI18nLegacy(Component) {
    const Wrapped = (props) => {
        const {t, locale, tz} = useContext(I18nContext);
        return <Component {...props} __i18n={{t, locale, tz}} />;
    };
    return Wrapped;
}
